$(function() {
  // Once a notification is hidden, remove it from the DOM.
  $('body').on('hidden.bs.toast', '.ecommerce-notification', function () {
    $(this).remove();
  })
});
